exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".scale-tool img{width:45px;height:auto;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-427c55fb!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fragment/scale-tool/index.vue
// module id = 169
// module chunks = 0